import * as React from 'react';
import {AppAssetKind, MARGEM_MAXIMA} from './appAssetCrop';
import {TextoAuxiliar} from './AppAssetPresentation';

interface Props {
  kind: AppAssetKind;
  zoom: number;
  setZoom: (v: number) => void;
  margem: number;
  setMargem: (v: number) => void;
  processando: boolean;
}

export const AppAssetCropControls = ({
  kind,
  zoom,
  setZoom,
  margem,
  setMargem,
  processando,
}: Props) => (
  <>
    <label htmlFor={`asset-zoom-${kind}`}>
      Zoom{' '}
      <span style={{float: 'right'}}>{zoom.toFixed(1)}×</span>
    </label>
    <input
      id={`asset-zoom-${kind}`}
      type="range"
      disabled={processando}
      min={1}
      max={3}
      step={0.01}
      value={zoom}
      onChange={(e) => setZoom(Number(e.target.value))}
    />
    <label htmlFor={`asset-margin-${kind}`}>
      Margem ao redor da imagem{' '}
      <span style={{float: 'right'}}>{Math.round(margem * 100)}%</span>
    </label>
    <input
      id={`asset-margin-${kind}`}
      type="range"
      disabled={processando}
      min={0}
      max={MARGEM_MAXIMA}
      step={0.01}
      value={margem}
      onChange={(e) => setMargem(Number(e.target.value))}
    />
    <TextoAuxiliar>
      A margem reduz a imagem e preenche as bordas com a cor escolhida.
      Confira o resultado ao lado.
    </TextoAuxiliar>
  </>
);
